import React, { useEffect } from 'react';

import ReactGA from 'react-ga';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Auth from 'src/components/Auth';
import CookiesNotification from 'src/components/CookiesNotification';
//import SettingsNotification from 'src/components/SettingsNotification';
//import GoogleAnalytics from 'src/components/GoogleAnalytics';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import Routes from 'src/Routes';
//import RoutesDev from 'src/RoutesDev';

import { VERSION_APP, VERSION_CODE } from './constants';
import getOS from './hooks/getOS';
import LoadingScreen from './components/LoadingScreen';
import { atob } from 'buffer';

const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// Initialize google analytics page view tracking
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID); // Aqui pones tu identificador de cuenta de Google Analytics

history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%'
    },
    '#root': {
      height: '100%',
      width: '100%'
    }
  }
}));

function MainApp() {
  useStyles();


  const { settings } = useSettings();
  const notistackRef = React.createRef();

  const handleVersionApp = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'versionApp', data: VERSION_APP, versionWeb: VERSION_CODE }));
    }
  }

  /**
   * Funcion para obtener el Id del dispositivo.
   * 
   * Ayuda a setear el Id del dispositivo en el localStorage para las peticiones e identificacion del usuario con su dispositivo seguro.
   * 
   * Obs: Se valida si el dispositivo es Android o IOS para agregar el evento de escucha del mensaje.
   * 
   * Obs: Se agrega el evento de escucha del mensaje para obtener el Id del dispositivo.
   * 
   * Obs: Se envia el mensaje al WebView para obtener el Id del dispositivo.
   * 
   * Obs: Se guarda el Id del dispositivo en el localStorage.
   * 
   * Obs: Si el dispositivo es un navegador web se utiliza la funcion de userAgent para obtener el Id del dispositivo.
   */
  const handleGetDeviceId = () => {

    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'getDeviceId', data: null }));
      }else {
          localStorage.setItem('deviceId', JSON.stringify({
            codigo: window.btoa("WEB"),
            imei: window.btoa(navigator.userAgent.toString()),
            modelo: window.btoa("WEB"),
            os: window.btoa("WEB"),
            osVersion: window.btoa("WEB")
          }));
      }
    } catch (error) {
      console.error('Error en getDeviceId:', error);
    }

    if (window.ReactNativeWebView) {
      getOS() === 'Android' ? document.addEventListener("message", handleMessage) : window.addEventListener("message", handleMessage);
    }
  }

  const handleMessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      console.log("handleMessage", data);
      if (data) {
        
        localStorage.setItem('deviceId', JSON.stringify({
          codigo: window.btoa(data?.codigo),
          imei: window.btoa(data?.imei),
          modelo: window.btoa(data?.modelo),
          os: window.btoa(data?.os),
          osVersion: window.btoa(data?.osVersion)
        }));
        getOS() === 'Android' ? document.removeEventListener("message", handleMessage) : window.removeEventListener("message", handleMessage);
      }
    } catch (error) {
      console.error('Error en handleMessage:', error);
      getOS() === 'Android' ? document.removeEventListener("message", handleMessage) : window.removeEventListener("message", handleMessage);
    }
  }

  useEffect(() => {
    handleGetDeviceId();
    handleVersionApp();

    return () => {
      getOS() === 'Android' ? document.removeEventListener("message", handleMessage) : window.removeEventListener("message", handleMessage);
    };
  }, []);



  return (
      <ThemeProvider theme={createTheme(settings)}>
        <StylesProvider jss={jss}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider
              ref={notistackRef}
              maxSnack={4}
              onClose={(event, reason) => {
                if (reason === "clickaway") {
                  (notistackRef.current).closeSnackbar();
                }
              }}
              autoHideDuration={20000}
            >
              <Router history={history}>
                <Auth>
                  <ScrollReset />
                  {/*<GoogleAnalytics />*/}
                  <CookiesNotification />
                  {/*<SettingsNotification />*/}
                  <Routes />
                </Auth>
              </Router>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </ThemeProvider>
  );
}

function App() {
  return <MainApp />;
}

export default App;
